import '@dfds-pax/ui/stylescvi.css'
import '@dfds-pax/ui/styles.css'
import './globals.css'

import ErrorBoundary from './ErrorBoundary'
import AppWithContent from './AppWithContent'
import { TravelSearchProvider } from './context/TravelSearchProvider'
import { ActiveSelectFieldProvider } from './context/ActiveSelectFieldProvider'

const App = ({ hasOffer }: { hasOffer: boolean | undefined }) => {
  return (
    <ErrorBoundary>
      <TravelSearchProvider>
        <ActiveSelectFieldProvider>
          <AppWithContent hasOffer={hasOffer} />
          <div data-e2e="deployed"></div>
        </ActiveSelectFieldProvider>
      </TravelSearchProvider>
    </ErrorBoundary>
  )
}

export default App
